<template>
  <div class="login-container">
    <nav-bar :showBack="false"/>

    <div v-if="clientName" class="page-title">
      {{ $t('登录授权标题前缀') }}<span class="client-name">{{ ' ' + clientName + ' '}}</span>{{ $t('登录授权标题后缀') }}
    </div>

    <img class="viomi-logo" src="@/icons/viomi_logo.png">

    <van-form @submit="onSubmit">

      <common-drop-down-view v-if="canSwitchRegion" :show-text="showRegion" @onDropDownClick="onRegionClick"/>
      <van-field v-model="user.mobile" class="custom-field" :placeholder="$t('请输入手机号')" type="number" clearable>
        <template #left-icon>
          <div class="area-code" @click="onAreaCodeClick">
            {{ mobilePrefix }}
            <van-icon name="arrow-down" />
          </div>
      </template>
      </van-field>
      <van-field v-show="isCaptcha" v-model="user.captcha" class="custom-field" :placeholder="$t('请输入图片验证码')" clearable>
        <template #button>
          <img :src="captchaSrc" class="captchaImg" @click="getCrateCaptchaSub">
        </template>
      </van-field>
      <van-field v-model="user.code" class="custom-field" :placeholder="$t('请输入验证码')" type="number" clearable>
        <template #button>
          <van-count-down v-show="isCountDownShow" ref="countDown" millisecond :time="1000*60" :auto-start="false" format="ss" @finish="finish">
            <template #default="timeData">
              <span class="countDownBlock">{{ $t('重新发送')+ '(' +timeData.seconds + 's)'}}</span>
            </template>
          </van-count-down>
          <span v-show="!isCountDownShow" class="send-sms-btn" @click="onSendSmsCode"> {{$t('获取验证码')}} </span>
        </template>
      </van-field>
      <van-button class="login-btn" :disabled="!user.mobile|| !user.code ||(isCaptcha&&!user.captcha)|| !protocolFlag" block type="info" native-type="submit" @touchstart="onFailed()">
        {{ $t('授权登录') }}
      </van-button>
      <entrance-view :data="entranceList" @clickEntrance="clickEntrance" />
      <protocol-view v-model="protocolFlag" :isSmsLogin="true" @clickProtocol="goLink"/>
    </van-form>
    <check-list-popup-view v-model="regionPopupShow" :title="$t('选择地区')" :select-index="regionSelectIndex" :option-list="regionOptionList" @onClickItem="onClickRegionItem"/>
    <tip-popup-view v-model="tipShow" :tip-content="tipContent" :button-content="tipButton"/>
    <van-popup v-model="show" round position="bottom" :style="{ height: '70%' }"><iframe class="iframeBody" :src="iframeLink"></iframe></van-popup>
  </div>
</template>
<script>
import { Icon, Form, Field, Button, CheckboxGroup, Checkbox, CountDown, Toast, Popup, Dialog } from 'vant'
import { sendLoginSmsCode } from '@/api/common/index'
import { Encrypt } from '@/utils/crypto.js'
import ProtocolView from '@/components/ProtocolView'
import NavBar from '@/components/NavBar'
import SwitchRegion from '@/mixin/switch-region'
import { mapGetters } from 'vuex'
import { EntranceType } from '@/config/entrance.js'
import EntranceView from '@/components/EntranceView'
import TipPopupView from '@/components/TipPopupView'
import PageBase from '@/mixin/page-base'
import CheckListPopupView from '@/components/CheckListPopupView'
import CommonDropDownView from '@/components/CommonDropDownView'

export default {
  mixins: [PageBase, SwitchRegion],
  components: {
    CommonDropDownView,
    CheckListPopupView,
    ProtocolView,
    TipPopupView,
    EntranceView,
    NavBar,
    [Icon.name]: Icon,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [CountDown.name]: CountDown,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog
  },
  props: {},
  data () {
    return {
      entranceList: [EntranceType.PWDLOGIN],
      user: {
        mobile: '',
        code: '',
        captcha: ''
      },
      show: false,
      iframeLink: '',
      isCountDownShow: false,
      protocolFlag: false
    }
  },
  computed: {
    ...mapGetters(['mobilePrefixList']),
    mobilePrefix() {
      const item = this.mobilePrefixList.filter(item => item.B === this.mobileRegion)[0]
      return item ? item.N : '+60'
    }
  },
  watch: {},
  created () {
  },

  mounted () {
    this.initParamter()
  },

  methods: {

    clickEntrance(entrance){
      this.$router.back()
    },

    onAreaCodeClick(){
      this.tryToRequestAreaConfigInfo().then(() => {
        this.$router.push({ path: '/mobile-prefix-list', query: this.$route.query })
      }).catch((error) => {
        this.showTipPopup(error, this.$t('确定'))
      })
    },

    onFailed () {
      if (this.user.mobile && this.user.code && !this.protocolFlag) {
        Toast(this.$t('请先同意服务条款'))
      }
    },
    onSubmit () {
      const user = this.user
      let data = {
        authorization: this.authorization()
      }

      data.mobileAuthentication = {
        areaCode: this.mobilePrefix,
        mobile: Encrypt(user.mobile),
        verifyCode: user.code,
        sourceChannel: 0
      }
      data.authentication = {
        loginType: 'mobile',
        userType: '2'
      }

      this.commonAuth(data)
    },

    onSendSmsCode () {
      if (!this.user.mobile) {
        Toast(this.$t('请输入手机号'))
        return
      }
      if (this.isCaptcha && !this.user.captcha) {
        Toast(this.$t('请输入图片验证码'))
        return
      }
      let data = {
        mobile: Encrypt(this.user.mobile),
        areaCode: this.mobilePrefix
      }
      if (this.isCaptcha) {
        data.captcha = this.user.captcha
      }

      this.showLoading(this.$t('获取验证码...'))
      sendLoginSmsCode(data).then(res => {
        this.dismissLoading()
        if (res.code === 100) {
          if (!res.mobBaseRes.result) {
            this.getCrateCaptchaSub()
          } else {
            Toast(this.$t('验证码已发送'))
            this.isCountDownShow = true
            this.$refs.countDown.reset()
            this.$refs.countDown.start()
          }
        } else {
          this.showTipPopup(res.desc, this.$t('确定'))
        }
      }).catch((error) => {
        this.dismissLoading()
        this.showTipPopup(error, this.$t('确定'))
      })
    },

    getCrateCaptchaSub () {
      this.getCrateCaptcha({ identifier: Encrypt(this.user.mobile) })
    },

    finish () {
      this.isCountDownShow = false
    },
    goLink (link) {
      this.iframeLink = link
      this.show = true
    }
  }
}
</script>
<style scoped lang="less">
.login-container {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  padding: 0px 24px;
  .viomi-logo {
    width: 59px;
    height: 52px;
    margin-top: 28px;
    margin-bottom: 24px;
    align-self: center;
  }
  .page-title {
    margin-bottom: 8px;
    font-size: 17px;
    font-weight: 500;
    color: #2C2C2C;
    align-self: center;
    text-align: center;

    .client-name {
      color: #00AAAE;
    }
  }
  .custom-field {
    background-color: #F5F7FA;
    margin-top: 8px;
    border-radius: 8px;
    font-size: 14px;
    .captchaImg {
      width: 104px;
      height: 36px;
    }
    .area-code {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 65px; /* 增加宽度 */
      height: 40px;
    }
  }

  .custom-field /deep/ .van-field__button {
      display: flex;
      align-items: center;
    }

  .custom-field /deep/ .van-field__control {
    border-bottom: none;
    height: 40px;
  }
  .forget-pwd {
    font-size: 12px;
    font-weight: 400;
    color: gray;
    align-self: flex-end;
    text-align: right;
    margin-top: 16px;
  }

  .input-desc {
    font-size: 10px;
    color: #999999;
    line-height: 20px;
    position: relative;
    opacity: 0;
  }
  .inputDescAct {
    opacity: 1;
    animation: myfirst 0.05s;
    -webkit-animation: myfirst 1s; /* Safari and Chrome */
  }
  @keyframes myfirst {
    0% {
      opacity: 0;
      left: 0px;
      top: 5px;
    }
    100% {
      opacity: 1;
      left: 0px;
      top: 0px;
    }
  }

  @-webkit-keyframes myfirst /* Safari and Chrome */ {
    0% {
      opacity: 0;
      left: 0px;
      top: 5px;
    }
    100% {
      opacity: 1;
      left: 0px;
      top: 0px;
    }
  }
  .send-sms-btn {
    height: 16px;
    line-height: 16px;
    font-size: 13px;
    color: #28beca;
  }
  .login-btn {
    margin-top: 16px;
    background: linear-gradient(90deg, #5fd1db 0%, #28beca 100%);
    border: none;
    border-radius: 8px;
    height: 48px;
    font-size: 14px;
    width:327px;
  }
  .countDownBlock {
    color: #ace6ebff;
    font-size: 13px;
  }
  .iframeBody {
    width: 100%;
    height: 100%;
  }
}
</style>
